module.exports = __webpack_public_path__ + "static/media/retirarDinero.568dab28.svg";